import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/Panel.css";

const Panel = () => {
  const [manualPayments, setManualPayments] = useState([]);
  const [amounts, setAmounts] = useState({});
  const [endMessage, setEndMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [withdrawals, setWithdrawals] = useState([]); // withdrawals state
  const [influencerName, setInfluencerName] = useState("");
  const [influencerLinks, setInfluencerLinks] = useState([]);
  const [error, setError] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  useEffect(() => {
    const isAdmin = localStorage.getItem("adminGate");
    if (isAdmin !== "passed") {
      navigate("/admin-gate");
    }
  }, [navigate]);

  // Fetch manual payments + withdrawals
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [paymentsRes, withdrawalsRes] = await Promise.all([
          axios.get(`${API_URL}/api/manual-payment/pending`),
          axios.get(`${API_URL}/api/withdraw`)
        ]);
        setManualPayments(paymentsRes.data);
        setWithdrawals(
          withdrawalsRes.data.filter((w) => !w.isArchived)
        );

      } catch (err) {
        console.error("Error fetching data", err);
      }
    };

    fetchData();
  }, [API_URL]);

  // Handle manual payment inputs
  const handleAmountChange = (paymentId, value) => {
    setAmounts((prev) => ({
      ...prev,
      [paymentId]: value,
    }));
  };

  // Confirm manual payment
  const handleConfirm = async (paymentId, userId) => {
    const amount = amounts[paymentId];
    if (!amount || isNaN(amount) || amount <= 0) {
      return alert("Please enter a valid amount.");
    }

    try {
      await axios.post(`${API_URL}/api/manual-payment/confirm`, {
        paymentId,
        userId,
        amount,
      });

      setManualPayments((prev) => prev.filter((p) => p._id !== paymentId));
      setAmounts((prev) => {
        const updated = { ...prev };
        delete updated[paymentId];
        return updated;
      });
    } catch (err) {
      console.error("Confirmation failed", err);
    }
  };

  // Reject manual payment
  const handleReject = async (paymentId) => {
    try {
      await axios.post(`${API_URL}/api/manual-payment/reject`, { paymentId });

      setManualPayments((prev) => prev.filter((p) => p._id !== paymentId));
      setAmounts((prev) => {
        const updated = { ...prev };
        delete updated[paymentId];
        return updated;
      });
    } catch (err) {
      console.error("Rejection failed", err);
    }
  };

  // End Gameweek
  const handleEndGameweek = async () => {
    setLoading(true);
    setEndMessage("");
    try {
      const res = await axios.post(`${API_URL}/api/gameweek/process-winners`);
      setEndMessage(res.data.message);
    } catch (error) {
      console.error("Error processing gameweek:", error);
      if (error.response?.data?.message) {
        setEndMessage(error.response.data.message);
      } else {
        setEndMessage("Failed to process gameweek. See console for details.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDeductTransferPoints = async () => {
    try {
     const res = await fetch(`${API_URL}/api/points/toggle-deduction`, {
        method: "POST",
      });
      const data = await res.json();
      alert(`Transfer point deduction is now ${data.deductTransferPoints ? "ON" : "OFF"}`);
    } catch (err) {
      console.error("Failed to toggle deduction:", err);
      alert("Failed to update deduction status.");
    }
  };

// This functions shows the admin the completed withdrawals and he click ok if he sees them
  const handleArchiveWithdrawal = async (id) => {
  try {
    await axios.put(`${API_URL}/api/withdraw/${id}/archive`);
    setWithdrawals((prev) => prev.filter((w) => w._id !== id));
  } catch (err) {
    console.error("Failed to archive withdrawal", err);
  }
};

 // Create influencer
 const handleCreateInfluencer = async () => {
  if (!influencerName.trim()) {
    setError("Please enter a name.");
    return;
   }
   try {
     const res = await axios.post(`${API_URL}/api/influencer/create`, {
      name: influencerName,
    });

    const newLink = res.data.referralLink;
    setInfluencerLinks((prev) => [...prev, { name: influencerName, link: newLink }]);
    setInfluencerName("");
    setError("");
   } catch (err) {
     console.error("Error creating influencer:", err);
     setError(err.response?.data?.error || "Failed to create influencer");
   }
 };

  // Copy to clipboard
 const handleCopy = (link) => {
  navigator.clipboard.writeText(link);
  alert("Link copied!");
 };


  return (
    <div className="panel-container">
      <h1>Admin Panel</h1>

      {/* End Gameweek Section */}
      <section className="gameweek-section">
        <h2>Gameweek Control</h2>
        <button
          className="end-gw-btn"
          onClick={handleEndGameweek}
          disabled={loading}
        >
          {loading ? "Processing..." : "End Current Gameweek"}
        </button>
        {endMessage && <p className="end-message">{endMessage}</p>}

        {/*Deduct Transfer points button*/}
        <button className="deduct-transfer-points-btn"onClick={handleDeductTransferPoints}>
          Deduct Transfer Points
        </button>
        <button className="end-head-to-head-matches" >
          End Head to Head matches
        </button>
      </section>


      {/* Manual Payments Section */}
      <section className="payments-section">
        <h2>Pending Manual Payments</h2>
        {manualPayments.length === 0 ? (
          <p>No pending manual payments found.</p>
        ) : (
          manualPayments.map((payment) => (
            <div key={payment._id} className="payment-card">
              <div className="payment-info">
                <p><strong>User ID:</strong> {payment.userId}</p>
                <p><strong>M-Pesa Code:</strong> {payment.mpesaCode}</p>
              </div>
              <div className="payment-actions">
                <input
                  type="number"
                  placeholder="Amount"
                  className="amount-input"
                  value={amounts[payment._id] || ""}
                  onChange={(e) => handleAmountChange(payment._id, e.target.value)}
                />
                <button
                  className="confirm-btn"
                  onClick={() => handleConfirm(payment._id, payment.userId)}
                >
                  Confirm
                </button>
                <button
                  className="reject-btn"
                  onClick={() => handleReject(payment._id)}
                >
                  Reject
                </button>
              </div>
            </div>
          ))
        )}
      </section>

      {/* Withdrawals Section */}
      <section className="withdrawals-section">
        <h2>Withdrawals (System Processed)</h2>
        {withdrawals.length === 0 ? (
          <p>No withdrawal requests found.</p>
        ) : (
          withdrawals.map((w) => (
            <div key={w._id} className="withdrawal-card">
              <div className="withdrawal-info">
                <p><strong>M-Pesa Number:</strong> {w.mpesaNumber}</p>
                <p><strong>M-Pesa Name:</strong> {w.mpesaName}</p>
                <p><strong>Amount:</strong> KES {w.amount}</p>
                <p>
                  <strong>Status:</strong>{" "}
                    <span className={`status ${w.status}`}>
                      {w.status.toUpperCase()}
                    </span>
                </p>
              </div>
              <div className="withdrawal-actions">
                  <button
                    className="mark-done-btn"
                    onClick={() => handleArchiveWithdrawal(w._id)}
                  >
                    Archive
                  </button>
              </div>
            </div>
          ))
        )}
      </section>

        {/* Influencer Section */}
      <section className="influencer-section">
        <h2>Influencer Links</h2>
        <div className="influencer-form">
          <input
            type="text"
            placeholder="Enter influencer name"
            value={influencerName}
            onChange={(e) => setInfluencerName(e.target.value)}
          />
          <button onClick={handleCreateInfluencer}>Generate Link</button>
        </div>
        {error && <p className="error">{error}</p>}

        <div className="influencer-links">
          {influencerLinks.length === 0 ? (
            <p>No influencer links created yet.</p>
          ) : (
          influencerLinks.map((inf, idx) => (
            <div key={idx} className="influencer-card">
              <p><strong>{inf.name}</strong></p>
              <p>{inf.link}</p>
              <button onClick={() => handleCopy(inf.link)}>Copy Link</button>
            </div>
            ))
         )}
        </div>
      </section>

    </div>
  );
};

export default Panel;
